module.exports = __webpack_public_path__ + "img/for_road2.dcc8572c.png";